import { FunctionComponent, useEffect, useState } from "react"
import { Button, Col, Form, Modal } from "react-bootstrap"

interface IKeycardModal {
	onHide: () => void
	keycards: string[]
	setKeycards: (p: string[]) => any
	index: number | null
}
const KeycardModal: FunctionComponent<IKeycardModal> = ({ onHide, keycards, setKeycards, index }) => {
	const [keycard, setKeycard] = useState<string>("")
	const [touched, setTouched] = useState<KeycardTouched>({})
	useEffect(() => {
		if (index != null) {
			setKeycard(keycards?.[index] || "")
			setTouched({})
		}
	}, [keycards, index])
	//
	const errors = validate(keycard)
	//
	const save = () => {
		if (index != null) {
			// the modal shouldn't be open if index is undefined
			// show errors on all fields
			setTouched({ keycard: true })
			// don't save if there are errors
			if (errors.keycard) {
				return
			}
			//
			if (keycards == null) {
				keycards = [] // in case this is the first row
			} else {
				keycards = [...keycards] // make sure useState registers it as a new object
			}
			// add a new row if this is an add
			if (keycards.length <= index) keycards.push("")
			// then we can edit the new or existing row the same way
			keycards[index] = keycard
			setKeycards(keycards) // update state
			onHide() // close the window
		}
	}
	const remove = () => {
		// the modal shouldn't be open if index is undefined
		// the remove button shouldn't be visible if keycards is undefined
		if (keycards && index != null) {
			keycards = [...keycards]
			keycards.splice(index, 1)
			setKeycards(keycards) // update state
			onHide() // close the window
		}
	}
	//
	return (
		<Modal show={index != null} onHide={onHide}>
			<Modal.Header closeButton={true}>
				<Modal.Title>Edit Keycard</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form.Group className="mb-3" controlId="keycard">
					<Form.Label>Keycard</Form.Label>
					<Form.Control
						value={keycard}
						onChange={(e) => setKeycard(e.target.value)}
						onBlur={() => setTouched({ ...touched, keycard: true })}
						isInvalid={touched.keycard && errors.keycard != null}
					/>
					<Form.Control.Feedback type="invalid">{errors.keycard}</Form.Control.Feedback>
				</Form.Group>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" disabled={false} onClick={onHide}>
					Cancel
				</Button>
				<Button variant="danger" hidden={index != null && index >= (keycards?.length || 0)} onClick={remove}>
					Remove
				</Button>
				<Col></Col>
				<Button variant="primary" disabled={false} onClick={save}>
					OK
				</Button>
			</Modal.Footer>
		</Modal>
	)
}
export default KeycardModal

const validate = (keycard?: string) => {
	const validationErrors: KeycardErrors = {}
	if (!keycard) validationErrors.keycard = "Keycard is required."
	return validationErrors
}

interface KeycardTouched {
	keycard?: boolean
}
interface KeycardErrors {
	keycard?: string
}
